@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup()" [eventHelpText]="eventHelpText" />
}
@if (useMsOptionRenderer) {
    <div
        class="option-group-container regular-option-container"
        msOptionGroupRenderer
        [tolerance]="isShowOptionImage || isShowHeadshotImage ? 35 : 25"
        [optionGroup]="optionGroup()"
        [style.--option-group-rows]="columnsDetermined ? visibleRows() : 0"
        [optionPickClass]="'.option-pick-placeholder > div'"
        (rerender)="rendererChange($event)">
        <ms-option
            *rxFor="let option of visibleOptions$; trackBy: trackOption"
            [tracking]="trackingSource"
            [option]="option"
            [optionGroup]="optionGroup()"
            [event]="event"
            [showPromoBadge]="!!crmPromotedOptionIdsMap[option.id]"
            [showSeperateOptionName]="isEpcotEnabled"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails"
            [isShowOptionImage]="isShowOptionImage || isShowHeadshotImage"
            [optionImages]="optionImages"
            [imageTemplate]="imageTemplate"
            [showPlayerStats]="showPlayerStats" />
        @for (option of optionGroup().options; track option.id) {
            <div class="option option-hidden">
                <div class="option-pick option-pick-placeholder">
                    <div>
                        <div class="name">{{ option.name }}</div>
                        @if (!option.online) {
                            <div class="lock option-group-lock-icon">
                                <vn-icon [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'" [size]="isEpcotEnabled ? '16' : '14'" />
                            </div>
                        } @else {
                            <div class="value option-value">
                                {{ option.nativePrice | msNativePriceFormatter }}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
} @else {
    <div
        class="option-group-container regular-option-container"
        [style.--option-group-rows]="visibleRows()"
        [class.us-grouped-list]="isUSGroupedListEnabled"
        [class.single]="!isUSGroupedListEnabled"
        [class.double]="isUSGroupedListEnabled">
        <ng-container *rxFor="let option of visibleOptions$; trackBy: trackOption; let i = index">
            <div class="option-stats-container">
                <ms-option
                    [class.us-grouped-list-option]="isUSGroupedListEnabled"
                    [class.option-bottom-border]="borderClass(i)"
                    [tracking]="trackingSource"
                    [option]="option"
                    [optionGroup]="optionGroup()"
                    [event]="event"
                    [showPromoBadge]="!!crmPromotedOptionIdsMap[option.id]"
                    [showSeperateOptionName]="isEpcotEnabled"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [isShowOptionImage]="isShowOptionImage || isShowHeadshotImage"
                    [optionImages]="optionImages"
                    [imageTemplate]="imageTemplate"
                    [showPlayerStats]="showPlayerStats" />

                @if (isPlayerStatisticsOpen(option)) {
                    <ms-player-statistics
                        [statistics]="optionGroupPlayerStatisticsService.playerStatistics()"
                        [marketFilter]="optionGroup().originalId"
                        [tracking]="tracking"
                        [optionGroupName]="optionGroup().name"
                        [messages]="playerStatisticsMessages()"
                        [isSheetViewOpen]="optionGroupPlayerStatisticsService.isSheetViewOpen()"
                        [event]="event"
                        [marketId]="option.optionGroupId?.toString()"
                        [playerName]="option.name"
                        [iFrameHeight]="optionGroupPlayerStatisticsService.iFrameHeight()"
                        [optionId]="option.id.toString()" />
                }
            </div>
        </ng-container>
    </div>
}
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData()" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}

<ng-template
    #imageTemplate
    let-option="option"
    let-event="event"
    let-showSeperateOptionName="showSeperateOptionName"
    let-isPriceBoost="isPriceBoost"
    let-optionImages="optionImages"
    let-optionName="optionName">
    @if (showPlayerStats) {
        <div class="option-name-stats-container">
            @if (isShowOptionImage || isShowHeadshotImage) {
                <ng-container
                    [ngTemplateOutlet]="jerseyTemplate"
                    [ngTemplateOutletContext]="{
                        option: option,
                        event: event,
                        showSeperateOptionName: showSeperateOptionName,
                        isPriceBoost: isPriceBoost,
                        optionImages: optionImages,
                        optionName: optionName,
                    }" />
            } @else {
                @let groupValue = optionGroup();
                @if (groupValue.detailedGrouping.playerStatsProps) {
                    <ms-player-stats
                        [playerStats]="event.playerStats"
                        [sportId]="event.sport.id"
                        [playerStatsProps]="groupValue.detailedGrouping.playerStatsProps"
                        [playerIds]="[option.player1Id]"
                        [source]="groupValue.source" />
                }
            }
        </div>
    } @else if (isShowOptionImage || isShowHeadshotImage) {
        <ng-container
            [ngTemplateOutlet]="jerseyTemplate"
            [ngTemplateOutletContext]="{
                option: option,
                event: event,
                showSeperateOptionName: showSeperateOptionName,
                isPriceBoost: isPriceBoost,
                optionImages: optionImages,
                optionName: optionName,
            }" />
    }
    @if (optionGroupPlayerStatisticsService.isPlayerStatisticsEnabled() && optionGroupPlayerStatisticsService.isPlayer(event, option.name)) {
        <div class="player-statistics-icon" [class.active]="isPlayerStatisticsOpen(option)" (click)="togglePlayerStatistics(option)">
            <vn-icon size="12" [name]="isPlayerStatisticsOpen(option) ? 'sports-stats-active' : 'sports-stats'" />
        </div>
    }
</ng-template>

<ng-template
    #jerseyTemplate
    let-option="option"
    let-event="event"
    let-showSeperateOptionName="showSeperateOptionName"
    let-isPriceBoost="isPriceBoost"
    let-optionImages="optionImages"
    let-optionName="optionName">
    <div class="jersey-container">
        <div class="attribute-key participant-jersey">
            @if (isShowHeadshotImage) {
                <ms-participant-image
                    [participantImage]="optionImages[option.id]"
                    [showLogoColor]="isShowHeadshotImage"
                    [participantType]="participantType.Player"
                    [sportId]="event.sport.id" />
            } @else if (isShowOptionImage) {
                <ms-participant-image
                    [participantImage]="optionImages[option.id]"
                    [participantType]="participantType.Team"
                    [sportId]="event.sport.id" />
            }
        </div>

        @if (showPlayerStats) {
            <div class="option-name-stats-container">
                <div
                    class="name"
                    [class.priceboost]="showSeperateOptionName && isPriceBoost"
                    [class.name-offline]="!showSeperateOptionName && !option.online">
                    {{ optionName }}
                </div>

                @let optionValue = optionGroup();
                @if (optionValue.detailedGrouping.playerStatsProps) {
                    <ms-player-stats
                        [playerStats]="event.playerStats"
                        [sportId]="event.sport.id"
                        [playerStatsProps]="optionValue.detailedGrouping.playerStatsProps"
                        [playerIds]="[option.player1Id]"
                        [source]="optionValue.source" />
                }
            </div>
        } @else {
            <div
                class="name"
                [class.priceboost]="showSeperateOptionName && isPriceBoost"
                [class.name-offline]="!showSeperateOptionName && !option.online">
                {{ optionName }}

                @if (
                    optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled() && optionGroupPlayerStatisticsService.isPlayer(event, option.name)
                ) {
                    <ms-player-stats
                        [class.regular-season-stats]="optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled()"
                        [statistics]="optionGroupPlayerStatisticsService.playerStatistics()"
                        [marketId]="option.optionGroupId?.toString()"
                        [seasonStatisticsMessage]="seasonStatisticsMessage().avg"
                        [isSeasonStatisticsEnabled]="optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled()"
                        [seasonStatisticsType]="SeasonStatisticsType.Average"
                        [optionId]="option.id.toString()" />
                }
            </div>
        }
    </div>
</ng-template>
